import React from 'react'
import classNames from 'classnames'
import { BasicTestimonialCardProps } from './types.d'

const BasicTestimonialCard = ({
  icon,
  sectionHeading,
  displayName,
  ctaLabel,
  restaurantName,
  classes
}: BasicTestimonialCardProps) => {
  const basicTestimonialCardClasses = classNames(
    classes,
    'grid-rows-[min-content]'
  )

  const renderName = () => {
    if (displayName || ctaLabel || restaurantName) {
      return (
        <div>
          {displayName && (
            <p className='text-default font-semibold'>{displayName}</p>
          )}
          {ctaLabel && <span className='text-secondary'>{ctaLabel}</span>}
          {ctaLabel && restaurantName && (
            <span>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
          )}
          {restaurantName && (
            <span className='text-secondary'>{restaurantName}</span>
          )}
        </div>
      )
    }
  }

  return (
    <div
      className={basicTestimonialCardClasses}
      data-testid='mds-basic-testimonial-card'
    >
      <div>
        {icon[0] && (
          <img
            src={icon[0].url}
            className='mb-2 md:mb-4 w-[40px] h-[40px]'
            alt='Testimonial Quote Icon'
          />
        )}
        {sectionHeading && (
          <p className='font-effra test-[1.25rem] leading-[1.75rem] text-default font-normal mb-2 md:mb-4'>
            {sectionHeading}
          </p>
        )}
        {renderName()}
      </div>
    </div>
  )
}

export default BasicTestimonialCard
